import React from 'react';
import Accordion from '../Accordion';
import {
  fileOptions,
  imageOptions,
  downloadImage as downloadChartImage,
  downloadTableImage
} from '../editor/PublishHelper';
import DownloadSelect from '../editor/DownloadSelect';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { setAction } from 'redux/actions/app';
import { download } from 'editor/core/highcharts-editor';
import { getEmbeddableHTML, getEmbeddableJSON, stringifyFn } from './utils/exportHelper';

type DownloadImageProps = {
  defaultSelection: boolean;
  containerClass?: string;
  smallHeaderText?: boolean;
  childrenClasses?: string;
  accordionClasses?: string;
};

const DownloadImage = (props: DownloadImageProps) => {
  const projectConfig = useSelector((state: RootState) => state.projectConfig);
  const chartConfig = useSelector((state: RootState) => state.chartEditorPage);
  const { type } = useSelector((state: RootState) => state.layoutEditorPage);
  const { aggregatedOptions, dataOptions, cssModules } = projectConfig;
  const { chart } = chartConfig;
  const { team } = useSelector((state: RootState) => state.profile);
  const dispatch = useDispatch();
  const planId = team && team.plan_id;
  const isChart = type === 'chart';
  const isTable = type === 'table';
  const options = isTable ? [imageOptions[0]] : imageOptions;

  const onClickFileDownload = (key: string) => {
    switch (key) {
      case 'html':
        return download('chart.html', getEmbeddableHTML(projectConfig, chartConfig), 'text/html');
      case 'json':
        return download('chart.json', stringifyFn(getEmbeddableJSON(projectConfig), null), 'application/json');
    }
  };

  const downloadImage = (key: string) => {
    if (type === 'chart') {
      downloadChartImage(key, chart);
    } else {
      // Tables
      downloadTableImage({
        aggregatedOptions,
        type,
        cssModules,
        dataOptions
      });
    }
  };

  const showPayupModal = () =>
    dispatch(
      setAction({
        isPaidPlanModalOpen: true
      })
    );

  return (
    <Accordion
      accordionClasses={`mt-0 bg-ev-grey ${props.accordionClasses}`}
      key={'project_download'}
      useInternalSelect={true}
      headerText={'Download'}
      defaultSelection={props.defaultSelection}
      childrenClasses={props.childrenClasses}
      smallHeaderText={props.smallHeaderText}
    >
      <div className={`buttons-container w-full ${props.containerClass}`}>
        <div>
          {(isChart || isTable) && (
            <DownloadSelect
              className="w-full ml-0"
              selectClassName="px-0 mb-2"
              selectOptions={options}
              plan_id={planId ?? 0}
              onClick={downloadImage}
              showPayupModal={showPayupModal}
              defaultValue={{
                key: 'image/png',
                label: 'PNG'
              }}
            />
          )}
          {isChart && (
            <DownloadSelect
              className="w-full ml-0"
              selectClassName="px-0 mb-2"
              selectOptions={fileOptions}
              plan_id={planId ?? 0}
              onClick={onClickFileDownload}
              showPayupModal={showPayupModal}
              defaultValue={{
                key: 'html',
                label: 'HTML'
              }}
            />
          )}
        </div>
      </div>
    </Accordion>
  );
};

export default DownloadImage;
